/**
 * The window, the verdict and the partner — the three filters the endpoint
 * actually takes.
 *
 * NOT IN THE DESIGN, kept deliberately. They are shipped function: the
 * artboard shows one screenful of one window and says nothing about how to
 * reach another, and deleting a working control to match a still image would
 * take away the only way to look at yesterday. They sit between the counters
 * and the table so the counters, which follow the same window, read as the
 * thing being filtered.
 *
 * `decision` is the POLICY's verdict. What became of a booking is
 * `resolution`, which the endpoint does not filter on — so it is not offered
 * here rather than being faked client-side over a 50-row page.
 */

import React from 'react';
import { Button } from 'react-bootstrap';
import { SINCE_OPTIONS } from '../useDecisionFeed';

const DECISION_FILTERS = [
  { value: '', label: 'Every verdict' },
  { value: 'held', label: 'Held for review' },
  { value: 'auto_approved', label: 'Auto-approved' },
  { value: 'auto_rejected', label: 'Auto-rejected' },
  { value: 'not_evaluated', label: 'No policy ran' },
  // The API has accepted this value since cancellations started being
  // recorded; without the option the only way to see them was to read past
  // every offer in the list.
  { value: 'partner_cancelled', label: 'Partner cancelled' },
];

function DecisionFilters({ feed }) {
  const {
    partners, decision, setDecision, partnerId, setPartnerId,
    sinceDays, setSinceDays, isLoading, reload,
  } = feed;

  return (
    <div className="sync-decision-controls">
      <label className="sync-decision-control">
        <span className="sync-meta-label">Since</span>
        <select
          className="form-select"
          value={sinceDays}
          onChange={(event) => setSinceDays(event.target.value)}
        >
          {SINCE_OPTIONS.map((option) => (
            <option value={option.value} key={option.value}>{option.label}</option>
          ))}
        </select>
      </label>

      <label className="sync-decision-control">
        <span className="sync-meta-label">Decision</span>
        <select
          className="form-select"
          value={decision}
          onChange={(event) => setDecision(event.target.value)}
        >
          {DECISION_FILTERS.map((option) => (
            <option value={option.value} key={option.value || 'all'}>{option.label}</option>
          ))}
        </select>
      </label>

      <label className="sync-decision-control">
        <span className="sync-meta-label">Partner</span>
        <select
          className="form-select"
          value={partnerId}
          onChange={(event) => setPartnerId(event.target.value)}
        >
          <option value="">Every partner</option>
          {(partners || []).map((partner) => (
            <option value={partner.Id} key={partner.Id}>{partner.name}</option>
          ))}
        </select>
      </label>

      <Button variant="outline-primary" onClick={reload} disabled={isLoading}>
        <i className={`fa fa-sync ${isLoading ? 'fa-spin' : ''} me-2`} />
        {isLoading ? 'Loading…' : 'Reload'}
      </Button>
    </div>
  );
}

export default DecisionFilters;
